export default "/images/Viihealth.png?5f3f96879d73cfd9da95a1c09fe08128";